<template>
  <div v-if="learningPaths && learningPaths.length" class="area-paths">
    <div class="area-paths__title-wrapper">
      <Passes :passName="area" :size="35" />
      <h6 class="area-paths__title">{{ area }}</h6>
    </div>
    <div class="area-paths__wrapper">
      <LearningPathTile
        v-for="path in learningPaths"
        :key="path.objectID"
        :path="path"
      />
    </div>
  </div>
</template>

<script>
import Passes from '@/components/properties/Passes.vue'
import LearningPathTile from '@/components/layout/LearningPathTile.vue'
import { mapState } from 'vuex'
import { algoliaSearchMixin } from '@/helpers/mixins'

export default {
  name: 'LearningPathsByLearningArea',
  components: {
    LearningPathTile,
    Passes,
  },
  mixins: [algoliaSearchMixin],
  props: {
    area: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapState({
      algoliaKeys: state => state.search.algoliaKeys,
    }),
    learningPaths() {
      return this.getIndexHits(this.algoliaKeys.searchIndex)
    },
  },
  watch: {
    area() {
      this.createAlgoliaSearchInstance()
    },
  },
  async created() {
    await this.createAlgoliaSearchInstance()
  },
  methods: {
    async createAlgoliaSearchInstance() {
      const searchIndex = this.algoliaKeys.searchIndex
      const helper = await this.initializeAlgoliaSearch(searchIndex, {
        facets: ['learning_areas.name', 'content_type'],
      })

      helper.addFacetRefinement('learning_areas.name', this.area)
      helper.addFacetRefinement('content_type', 'learning-path')
      helper.setQueryParameter('hitsPerPage', 200)
      helper.search()
    },
  },
}
</script>

<style lang="scss">
.area-paths {
  &__title-wrapper {
    display: flex;
    align-items: center;
    padding: 50px 0 20px 0;
  }
  &__title {
    padding: 0;
    color: var(--white);
    margin: -5px 0 0 10px;
    font-family: var(--font-bold);
    text-transform: uppercase;
    font-size: 1rem;
  }
  &__wrapper {
    display: grid;
    grid-template-columns: 1fr;
    gap: 10px;
    @include mobile {
      grid-template-columns: repeat(2, 1fr);
    }
    @include tablet {
      gap: 20px;
      grid-template-columns: repeat(3, 1fr);
    }
    @media (min-width: 1500px) {
      grid-template-columns: repeat(4, 1fr);
    }
  }
}
</style>
